module.exports = __webpack_public_path__ + "static/media/zocalo6.b073ba33.jpg";